import { sendAnalytics } from '@audio-network/analytics'

import { AutocompletePlugin } from '@/components/pages/search/SearchBox/SearchBox.types'
import type { AutocompleteFetcher } from '@/utils/algolia/autocomplete'
import { shouldShowCuratedAutocompleteSections } from '@/utils/algolia/autocomplete/utils'
import type { CollectionHit } from '@/utils/algolia/autocompleteHitTypes'

export const collectionsPlugin = (
	fetchAutocomplete: AutocompleteFetcher
): AutocompletePlugin<CollectionHit> => {
	return {
		name: 'collectionsPlugin',
		getSources({ query }) {
			if (!shouldShowCuratedAutocompleteSections(query)) {
				return []
			}

			return [
				{
					sourceId: 'collectionsSource',
					getItemUrl({ item }) {
						return item.url
					},
					getItems({ query }) {
						return fetchAutocomplete(query).then((b) => b.collectionHits)
					},
					onSelect({ item }) {
						sendAnalytics({
							noun: 'Collection',
							pastTenseVerb: 'Clicked',
							eventParameters: {
								Name: item.value,
								UrlSlug: item.url.split('/').pop(),
								Source: 'Typeahead',
							},
						})

						sendAnalytics({
							noun: 'Typeahead',
							pastTenseVerb: 'Submitted',
							eventParameters: {
								CollectionTitle: item.value,
								Type: 'Collection',
							},
						})
					},
				},
			]
		},
	}
}
